import React from "react";

const Paragraph = (props) => {
    const {  ...rest } = props;
    const styles = 
        {

            padding: 0,
            margin: 0,
            ...props?.style,
        ...(!Array.isArray(props?.style) ? props?.style : {}),
    };

    return <p style={styles} {...rest} >{props.text}{props.children}</p> ;
};

export default Paragraph;
